import createErrorType from 'app/utils/createErrorType';
import { decodeOrThrow } from 'app/utils/ioTs';
import { chain } from 'fp-ts/lib/Either';
import { pipe } from 'fp-ts/lib/pipeable';
import * as t from 'io-ts';

export class InvalidDateError extends createErrorType('InvalidDateError') {
  public constructor(dateStr: string) {
    super(`Expected a date string, given ${dateStr}`);
  }
}

export const DateMarshallerType = new t.Type<Date, string, unknown>(
  'DateMarshallerType',
  (d: unknown): d is Date => d instanceof Date,
  (d, c) => {
    return pipe(
      t.string.validate(d, c),
      chain((right) => {
        const timestamp = Date.parse(right);
        return isNaN(timestamp) ? t.failure(right, c, 'Not a valid date string.') : t.success(new Date(timestamp));
      }),
    );
  },
  (d: Date) => d.toISOString(),
);

export const DateMarshaller = {
  deserialize: (date: unknown): Date => {
    return decodeOrThrow(DateMarshallerType, date, (errors) => {
      throw new InvalidDateError(errors.join('\n'));
    });
  },
  serialize: DateMarshallerType.encode,
};
